import { render, staticRenderFns } from "./DashboardViewEditingTabConfig.vue?vue&type=template&id=4a7c8f28"
import script from "./DashboardViewEditingTabConfig.vue?vue&type=script&lang=js"
export * from "./DashboardViewEditingTabConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports